import { Box, Button, Card, Checkbox, Grid, TextInput } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Metadata from '../../components/Metadata';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';
import { getAuthenticatedUser } from '../../store/authSlice';

const SettingsUserPage = () => {
  const fetch = useFetch();
  const [user, setUser] = useState();
  const [error, setError] = useState();

  const dispatch = useDispatch();
  const authUser = useSelector((state) => state.auth.user);

  useEffect(() => {
    if (authUser) {
      setUser(authUser);
    }
  }, [authUser]);

  if (!authUser || !user) {
    return;
  }

  const changed = JSON.stringify(authUser) !== JSON.stringify(user);

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const submitForm = (e) => {
    e.preventDefault();
    setError(undefined);
    fetch(`/api/admin/users`, {
      method: 'PUT',
      body: JSON.stringify(user),
    })
      .then(() => {
        dispatch(getAuthenticatedUser());
        setError(undefined);
      })
      .catch(setError);
  };

  return (
    <div>
      <Metadata title={`${Page['settings']} | User`} />
      <Grid pt={60}>
        <Grid.Col span={{ base: 12, md: 4 }}></Grid.Col>
        <Grid.Col span={{ base: 12, md: 4 }}>
          <Card withBorder>
            <Card.Section inheritPadding py="sm">
              <Box component="form" ta="left" onSubmit={(e) => submitForm(e)}>
                <TextInput
                  name="firstName"
                  label="First Name"
                  placeholder="John"
                  value={user.firstName || ''}
                  error={user.firstName !== undefined && user.firstName === '' ? 'First name is required' : null}
                  onChange={handleChange}
                  mb="sm"
                />
                <TextInput
                  name="lastName"
                  label="Last Name"
                  placeholder="Doe"
                  value={user.lastName || ''}
                  error={user.lastName !== undefined && user.lastName === '' ? 'Last name is required' : null}
                  onChange={handleChange}
                  mb="sm"
                />
                <TextInput
                  name="email"
                  type="email"
                  label="Email"
                  placeholder="Your Email"
                  value={user.email || ''}
                  error={
                    (user.email !== undefined && user.email === '') ||
                    (error && error.errors?.find((e) => e.path === 'email'))
                      ? error?.errors?.find((e) => e.path === 'email')?.message || 'email cannot be blank'
                      : null
                  }
                  onChange={handleChange}
                  mb="sm"
                />
                <TextInput
                  name="phoneNumber"
                  label="Phone Number"
                  placeholder="+11234567890"
                  value={user.phoneNumber || ''}
                  error={
                    (user.phoneNumber !== undefined && user.phoneNumber === '') ||
                    (error && error.errors?.find((e) => e.path === 'phoneNumber'))
                      ? error?.errors?.find((e) => e.path === 'phoneNumber')?.message || 'phone number cannot be blank'
                      : null
                  }
                  onChange={handleChange}
                  mb="sm"
                />
                <TextInput
                  name="password"
                  type="password"
                  label="Password"
                  placeholder="Your Password"
                  value={user.password || ''}
                  onChange={handleChange}
                  autoComplete="new-password"
                  mb="sm"
                />
                <TextInput
                  name="passwordConfirmation"
                  type="password"
                  label="Confirm password"
                  placeholder="Your Password"
                  error={user.password && user.password !== user.passwordConfirmation ? 'passwords do not match' : null}
                  value={user.passwordConfirmation || ''}
                  onChange={handleChange}
                  autoComplete="new-password"
                  mb="sm"
                />
                <Checkbox
                  name="subscribedAt"
                  label="Receive Automated Reports?"
                  onChange={(e) =>
                    handleChange({
                      target: { name: 'subscribedAt', value: e.currentTarget.checked ? new Date() : null },
                    })
                  }
                  checked={!!user.subscribedAt}
                  mb="sm"
                />
                <Box display="flex" style={{ justifyContent: 'flex-end' }}>
                  <Button
                    type="submit"
                    disabled={
                      !user.firstName ||
                      !user.lastName ||
                      !user.email ||
                      user.password !== user.passwordConfirmation ||
                      !changed
                    }
                  >
                    {changed ? 'Save' : 'Saved'}
                  </Button>
                </Box>
              </Box>
            </Card.Section>
          </Card>
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 4 }}></Grid.Col>
      </Grid>
    </div>
  );
};

export default SettingsUserPage;
